import React from 'react';

function SocialMedia() {
	return (
		<div className="social-media-icons">
			<a
				target="_blank"
				href="https://twitter.com/jorenrui/"
				rel="noopener noreferrer"
			>
				<i
					className="fab fa-twitter fa-lg"
					title="Joeylene Rivera's Twitter Profile"
				></i>
			</a>
			<a
				target="_blank"
				href="https://instagram.com/jorenrui/"
				rel="noopener noreferrer"
			>
				<i
					className="fab fa-instagram fa-lg"
					title="Joeylene Rivera's Instagram Profile"
				></i>
			</a>
			<a
				target="_blank"
				href="https://github.com/jorenrui/"
				rel="noopener noreferrer"
			>
				<i
					className="fab fa-github fa-lg"
					title="Joeylene Rivera's GitHub Profile"
				></i>
			</a>
			<a
				target="_blank"
				href="https://dev.to/jorenrui"
				rel="noopener noreferrer"
			>
				<i
					className="fab fa-dev fa-lg"
					title="Joeylene Rivera's DEV Profile"
				></i>
			</a>
			<a
				target="_blank"
				href="https://www.linkedin.com/in/jorenrui/"
				rel="noopener noreferrer"
			>
				<i
					className="fab fa-linkedin fa-lg"
					title="Joeylene Rivera's LinkedIn Profile"
				></i>
			</a>
		</div>
	);
}

export default SocialMedia;
